import { useSettings } from '@/contexts/SettingsContext';
import { buildWhatsAppUrl } from '@/lib/utils';
import { trackEvent } from '@/lib/api';
import { Phone, MessageCircle } from 'lucide-react';

export function MobileCTA({ vehicle, pageUrl }) {
    const { settings } = useSettings();

    const handleWhatsApp = () => {
        trackEvent({
            event_type: 'whatsapp_click',
            vehicle_id: vehicle?.id,
            vehicle_title: vehicle?.title
        }).catch(() => {});
    };

    const handleCall = () => {
        trackEvent({
            event_type: 'call_click',
            vehicle_id: vehicle?.id,
            vehicle_title: vehicle?.title
        }).catch(() => {});
    };

    return (
        <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white/95 backdrop-blur-md border-t shadow-lg" data-testid="mobile-cta-bar">
            <div className="flex gap-2 p-3 max-w-lg mx-auto">
                <a
                    href={`tel:${settings?.phone || '+34600000000'}`}
                    className="flex-1 flex items-center justify-center gap-2 py-3 rounded-lg border border-[var(--brand-navy)] text-[var(--brand-navy)] font-medium text-sm transition-colors duration-200 hover:bg-[var(--brand-light-blue)] active:scale-[0.99]"
                    data-testid="mobile-call-button"
                    onClick={handleCall}
                >
                    <Phone className="h-4 w-4" />
                    Llamar
                </a>
                <a
                    href={buildWhatsAppUrl(settings, vehicle, pageUrl)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-1 flex items-center justify-center gap-2 py-3 rounded-lg bg-[#25D366] text-white font-medium text-sm transition-colors duration-200 hover:bg-[#20BD59] active:scale-[0.99]"
                    data-testid="mobile-whatsapp-button"
                    onClick={handleWhatsApp}
                >
                    <MessageCircle className="h-4 w-4" />
                    WhatsApp
                </a>
            </div>
        </div>
    );
}
